export enum EventStatus {
  Scheduled = 'Scheduled',
  Complete = 'Complete',
}

export enum PaymentTypeStatus {
  Cash = 'Cash',
  Invoice = 'Invoice',
}
